import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  height: 40px;
  width: 250px;
  line-height: 40px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 12px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  & > span.limit-text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &:hover {
    cursor: pointer;
  }

  ${({ inactive }) =>
    inactive &&
    `
    & > span {
      opacity:0.5;
    }
  `}
`;

export const Actions = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: right;
  background: #eee;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
